export const getDistributorGroupForUser = (distributorGroups, user) => {
  if (user.type === 'Authenticated') {
    const agentType = user.profile.agent_type ? user.profile.agent_type : 'AGENT'
    const distributorGroupForUser = distributorGroups.find((distributorGroup) =>
      distributorGroup.agentTypes.includes(agentType)
    )
    return distributorGroupForUser ? distributorGroupForUser.id : 'AGENT'
  } else {
    return 'AGENT'
  }
}

/**
 * @param distributorGroupRepository {ReturnType<import('core/data-model/distributor/repository').createDistributorGroupRepository>}
 */
export function createDistributorGroupService(distributorGroupRepository) {
  const getDistributorGroups = () => distributorGroupRepository.listDistributorGroups()

  return {
    getDistributorGroups,
  }
}
